import initMortgageCalculators from "./component/MortgageCalculator";
initMortgageCalculators();

import GraphCalculators from './component/GraphCalculators';
if (document.querySelector('.compareAccountForm')) {
	new GraphCalculators(document);
}
